import CountryList from './CountryList';

export default {
    list: 	CountryList
};
